import { enums } from '@optimizely/optimizely-sdk';

import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { isSSR } from '@telialt/utils/src/helpers';

export const customLogger = function (level: number, message: string) {
    const LOG_LEVEL = enums.LOG_LEVEL;

    if (level === LOG_LEVEL.ERROR) {
        const datadogLogs = datadogLogger();
        datadogLogs.error(message, { component: DDComponent.Optimizely });
    }

    if (level === LOG_LEVEL.ERROR || !isSSR()) {
        // eslint-disable-next-line no-console
        console.log(message);
    }
};
